var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVetBackEn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9312 4.46863C16.556 5.09347 16.556 6.10653 15.9312 6.73137L10.6625 12L15.9312 17.2686C16.556 17.8935 16.556 18.9065 15.9312 19.5314C15.3063 20.1562 14.2933 20.1562 13.6684 19.5314L7.26843 13.1314C6.64359 12.5065 6.64359 11.4935 7.26843 10.8686L13.6684 4.46863C14.2933 3.84379 15.3063 3.84379 15.9312 4.46863Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVetBackEn);
export default __webpack_public_path__ + "static/media/vet-back-en.e08ee5708de824e977aee0e845c03435.svg";
export { ForwardRef as ReactComponent };